const validator = require("email-validator");
const mailcheck = require('mailcheck');

// const modal = document.querySelector('#modal');
// const modalClose = document.querySelector('.modal__close');
// const modalBg = document.querySelector('.modal__bg');

// const url = new URL(window.location.href);
// const isVisible = url.searchParams.get('customer_posted');

// if (isVisible) {
//   modal.classList.add('is-active');

//   // Close modal on click of close button
//   modalClose.addEventListener('click', (event) => {
//     event.preventDefault();
//     modal.classList.remove('is-active');
//     url.searchParams.delete('customer_posted');
//   });

//   // Close modal on click of bg
//   if (modalBg) {
//     modalBg.addEventListener('click', (event) => {
//       modal.classList.remove('is-active');
//       url.searchParams.delete('customer_posted');
//     });
//   }

//   load('*');
// }


class NewsletterSignup extends HTMLElement {

  constructor() {
    super();
    const _email = this.querySelector("#fieldEmail");
    const _name = this.querySelector('#fieldName');
    const _emailConfirmation = this.querySelector('#fieldEmailConfirmation');

    const domains = ['gmail.com', 'outlook.com', 'hotmail.com', 'hotmail.co.uk', 'hotmail.fr', 'msn.com', 'aol.com', 'icloud.com', 'talktalk.com', 'yahoo.com', 'proton.com', 'proton.me', 'sky.com', 'doctors.org.uk', 'doctors.org', 'doctors.uk', 'me.com', 'maildrop.cc'];
    const secondLevelDomains = ['hotmail'];
    const topLevelDomains = ["com", "net", "org", "uk", "gov", "ac", "co.uk", "ac.uk", "sch.uk", "doctors", "me"];

    this.querySelector("form").addEventListener("submit", (e) => {
      e.preventDefault();

      if (_emailConfirmation.value !== '') {
        this.checkEmailsMatch();
        return;
      }

      const isEmailValid = validator.validate(_email.value);
      const isEmailCorrect = mailcheck.run({
        domains,
        topLevelDomains,
        email: _email.value,
        suggested: (res) => {
          return res;
        }
      });

      // automatically suggestions an email if there is a typo
      if (isEmailValid) {
        if (isEmailCorrect?.full) {
          _emailConfirmation.classList.remove('visually-hidden');
        } else {
          this.subscribeCustomer(_email.value, _name.value, this);
        }
      } else {
        _emailConfirmation.classList.remove('visually-hidden');
      }
    });

  }

  checkEmailsMatch() {
    const _email = this.querySelector("#fieldEmail");
    const _name = this.querySelector('#fieldName');
    const _emailConfirmation = this.querySelector("#fieldEmailConfirmation");

    if (_email.value !== _emailConfirmation.value) {
      this.querySelector('#emails-do-not-match').classList.remove('visually-hidden');

      setTimeout(() => {
        this.querySelector('#emails-do-not-match').classList.add('visually-hidden');
      }, 4500);
    } else {
      this.subscribeCustomer(_email.value, _name.value, this);
    }
  }

  static get observedAttributes() {
    return ["data-sent"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    const d = this.getAttribute("data-sent");
    if (name === "data-sent") {
      this.resetForm();
    }
  }

  // shows hidden fields
  resetForm() {
    this.querySelectorAll('input').forEach((el) => {
      el.classList.add('visually-hidden');
    });
    this.querySelectorAll('button').forEach((el) => {
      el.classList.add('visually-hidden');
    });
    this.closest('.form-vertical').querySelectorAll('.newsletter__title header').forEach((el) => {
      el.classList.add('visually-hidden');
    });
    this.closest('.form-vertical').querySelectorAll('.pre-submission-text').forEach((el) => {
      el.classList.add('visually-hidden');
    });
    this.querySelectorAll('.post-sub-img').forEach((el) => {
      el.classList.remove('visually-hidden');
    });
    this.querySelectorAll('.post-submission-text').forEach((el) => {
      el.classList.remove('visually-hidden');
    });

    this.closest('.newsletter__grid').querySelector('.newsletter__info').classList.add('visually-hidden');

    document.querySelector('.signup-wrapper').classList.add('post-sub-aligned');

  }

  async subscribeCustomer(_e, _n, _parent) {

    try {

      const url = 'https://a.klaviyo.com/client/subscriptions/?company_id=Um6rUb';


      const options = {
        method: 'POST',
        headers: {revision: '2024-02-15', 'content-type': 'application/json'},
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Beauty Secrets Sign Up - via API',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: `${_e}`,
                    first_name: `${_n}`,
                    properties: {emailValidated: true}
                  }
                }
              }
            },

            relationships: {list: {data: {type: 'list', id: 'Yc9yQZ'}}}

          }
        })
      };

      const request = await fetch(url, options);
      console.log(request);
      _parent.setAttribute('data-sent', true);
      return request;

    } catch (err) {
      console.error('uh oh! There was an error adding customer to the wait list: ', err);
    }

  }

}


customElements.define('newsletter-signup', NewsletterSignup);
